// var pingBase = {
//   policy_group_id: 'TechRev Policy',
//   client_id: 'nike.niketech.token-generator',
//   response_type: 'id_token token',
//   scope: 'profile openid email',
//   nonce: '1',
//   redirect_uri: window.location.origin.indexOf('localhost') === -1
//     ? window.location.origin
//     : window.location.origin.replace('localhost', '127.0.0.1')
// }

let oktaBase = {
  client_id: 'nike.niketech.token-generator',
  scope: 'profile openid email',
  state: '1',
  nonce: '1',
  response_type: 'id_token token',
  redirect_uri: window.location.origin
}

const config = {
  title: 'Token Generator',
  slack: {
    teamId: 'T0G3T5X2B',
    channelId: 'CFXBSE2G6'
  },
  clients: {
    oktaDev: {
      name: 'Okta Dev',
      authorizeUrl: 'https://nike.oktapreview.com/oauth2/ausabc0n6pDe7fmcE0h7/v1/authorize',
      auth: { ...oktaBase }
    },
    oktaQaDev: {
      name: 'Okta QA (Dev)',
      authorizeUrl: 'https://nike-qa.oktapreview.com/oauth2/ausafr23iuLzxT3HZ0h7/v1/authorize',
      auth: { ...oktaBase }
    },
    oktaQa: {
      name: 'Okta QA',
      authorizeUrl: 'https://nike-qa.oktapreview.com/oauth2/ausa0mcornpZLi0C40h7/v1/authorize',
      auth: { ...oktaBase }
    },
    oktaProd: {
      name: 'Okta Prod',
      authorizeUrl: 'https://nike.okta.com/oauth2/aus27z7p76as9Dz0H1t7/v1/authorize',
      auth: { ...oktaBase }
    }
  }
}

export default config
